export const initialMarketPlacesOptions = [
    { id: 3, marketPlace: 'ecooparts', checked: false },
];